import getFormSession from "../../../Components/CluppForms/getFormSession";
import { getProductData } from "../../../utils/getUserUtility";
import AceptPause from "./AceptPause";
import isADeviceCheck from "../../../utils/isADeviceCheck";
import fetchPauseSubscription from "../../../Services/users/fetchPauseSubscription";
import abandonCancelation from "../abandonCancelation";

const landingId = "CF_ACEPT_PAUSE";

function formatDateFromTimestamp(timestamp) {
  const date = new Date(timestamp);

  const day = date.getUTCDate();
  const year = date.getFullYear();

  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const month = months[date.getUTCMonth()];

  return `${day} de ${month} ${year}`;
}

const onLoad = async ({
  session,
  landedAt,
  uid,
  fieldsStructure,
  navigate,
}) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const lastLanding = landings[landings.length - 1];
  const lastLandingMetadata = lastLanding.metadata;

  const { monthsToPause, pid, pType } = lastLandingMetadata;
  try {
    const productData = await getProductData(uid, { id: pid, type: pType });

    const { insurancePauseCount, brand, model, year } = productData;
    if (insurancePauseCount >= 1) {
      return {
        userId: uid,
        haveAPause: true,
        ...prevAnswers,
        landedAt,
        prevForm,
        currentLanding: landingId,
      };
    } else {
       const response = await fetchPauseSubscription({
        uid,
        productId: pid,
        productType: pType,
        monthsToPause,
      }); 

      const { resumesAt } = response; 

      const state = {
        userId: uid,
        isADevice: isADeviceCheck(pType),
        haveAPause: false,
        productName: `${brand} ${model} ${year || ""}`,
        resumesAt: formatDateFromTimestamp(resumesAt) ,
        ...prevAnswers,
        landedAt,
        prevForm,
        currentLanding: landingId,
      };

/*       await abandonCancelation({
        session,
        state,
        uid,
      }); */

      return state;
    }
  } catch (err) {
    console.log(`Ocurrio un error inesperado en al landing: ${landingId}`, err);
    navigate(`/formulario/cancelacion/error-pausar?uid=${uid}`);
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {};

const content = ({ state, setState }) => (
  <AceptPause state={state} /> // Field ID
);

const nextPage = (props) => ``;
const prevPage = (props) => ``;

const fieldsStructure = [];

const aceptPauseProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default aceptPauseProps;
